angular.module("ricercaFiliale.components", [])
  .component("ricercaFiliale", {
    templateUrl: "ng/components/ricercaFiliale/ricercaFiliale.view.html",
    bindings: {
      hideFirstRow: '<',
      model: '=',
      validityComponent: '&',
      showHideComponent: '&',
      snapshot: "<",
      getBankCont: "&?"
    },
    controllerAs: "ricercaFilialeCtrl",
    controller: RicercaFilialeController
  })

function RicercaFilialeController(
  $financialApiService
) {
  var self = this;

  self.$onInit = function () {
    self.supportModel = {
      filiale: {
        ndg: null,
        abi: null,
        location: null,
        cab: null,

      },
      abiLoader: false,
      dropdown: {
        abiCode: [],
        cabCode: [],
        relatedVendors: []
      }
    }
    retrieveAbi();
  }

  var retrieveAbi = function () {
    self.supportModel.abiLoader = true;
    $financialApiService.getAllAbi()
      .then(function (responseAbi) {
        self.supportModel.dropdown.abiCode = responseAbi;
        if (responseAbi && responseAbi.length == 1) {
          self.supportModel.filiale.abi = responseAbi[0];
          self.checkFieldsChange('abi', self.supportModel.filiale.abi)
        }
        checkVisibleComponent();
      })
      .catch(function (error) {
        console.log(error);
      })
      .finally(function () {
        self.supportModel.abiLoader = false;
      })
  }

  var checkVisibleComponent = function () {
    self.showHideComponent({
      value: !!self.supportModel.dropdown.abiCode.length
    })
  }

  self.retrieveCab = function (abi, location) {
    if (self.abiSelected != abi || self.locationSelected != location) {
      self.supportModel.dropdown.cabCode = null;
      self.abiSelected = abi;
      self.locationSelected = location;
      self.supportModel.cabLoader = true;
      self.cabReturned = true;

      $financialApiService.getAllCab(abi, location)
        .then(function (responseCab) {
          self.supportModel.dropdown.cabCode = responseCab;
          if (self.supportModel.dropdown.cabCode.length == 0) {
            self.cabReturned = false;
          }
          if (responseCab && responseCab.length == 1) {
            self.supportModel.filiale.cab = responseCab[0];
            self.checkFieldsChange('cab', self.supportModel.filiale.cab)
          }
        })
        .catch(function (error) {
          console.log(error);
        })
        .finally(function () {
          self.supportModel.cabLoader = false;
        })
    }
  }

  self.checkFieldsChange = function (property, value) {
    if (property == 'abi') {
      if (value && value.value) {
        self.model[property] = value.value
      } else {
        self.model[property] = null;
        self.model.cab = null;
        self.supportModel.filiale.cab = null;
      }
      self.retrieveCab(self.supportModel.filiale.abi.value, self.supportModel.filiale.location)
    } else if (property == 'cab') {
      if (value && value.name) {
        self.model.filiale.cab = self.supportModel.filiale.cab
        self.model[property] = value.name
        self.getBankCont()
      } else {
        self.model[property] = null;
      }
    }
    checkComponent();
  }

  var checkComponent = function () {

    var check = !!self.model.abi &&
      !!self.model.cab

    self.validityComponent({
      value: check
    })
  }
}